import { Button, ButtonSection } from './styled/button'
import { FadeMain } from './styled/containers'
import { P } from './styled/typography'

type ErrorBoundaryFallbackProps = {
  readonly message?: string
  readonly actionLabel?: string
  readonly onAction?: () => void
}

const ErrorBoundaryFallback = ({
  message = 'Sorry, an error has occurred.',
  actionLabel,
  onAction,
}: ErrorBoundaryFallbackProps) => (
  <FadeMain wide>
    <P color="whiteAlpha50" css={{ marginTop: '5em', textAlign: 'center' }}>
      {message}
    </P>
    {actionLabel && onAction ? (
      <ButtonSection>
        <Button onClick={onAction}>{actionLabel}</Button>
      </ButtonSection>
    ) : null}
  </FadeMain>
)

export default ErrorBoundaryFallback
